import eachDayOfInterval from 'date-fns/eachDayOfInterval';

export const summerplayToWeekDays = (occ) => {
  if (!occ || !occ.start_date || !occ.end_date) return [];

  const start = new Date(occ.start_date);
  const end = new Date(occ.end_date);

  const days = eachDayOfInterval({ start, end });

  return days.map((day, index) => ({ id: index, date: day, checked: true }));
};
